/**
 * Portal Copy Fragment
 * Handles copy form submission state (disable buttons, show processing)
 */

import { Events } from '../../../../js/utils/events.js';

let initialized = false;

// ============================================================================
// Portal Copy Handlers
// ============================================================================

const PortalCopyHandlers = {
    /**
     * Handle HTMX beforeRequest on copy form
     * Disables buttons and shows processing message
     */
    onCopyFormBeforeRequest(e) {
        const form = e.target;
        if (!form || !form.id || !form.id.includes('copy-form')) return;

        const copyButton = form.querySelector('#copy-button');
        const cancelButton = form.querySelector('#cancel-button');
        const processingMessage = form.querySelector('#processing-message');

        // Disable buttons
        if (copyButton) {
            copyButton.disabled = true;
            copyButton.style.opacity = '0.5';
        }
        if (cancelButton) {
            cancelButton.disabled = true;
            cancelButton.style.opacity = '0.5';
        }

        // Show processing message
        if (processingMessage) {
            processingMessage.style.display = 'block';
        }
    }
};

// ============================================================================
// Initialization
// ============================================================================

export function initPortalCopy() {
    if (initialized) return;
    initialized = true;

    // Listen for HTMX beforeRequest on copy forms
    document.body.addEventListener('htmx:beforeRequest', (e) => {
        const form = e.target.closest('#copy-form');
        if (form) {
            PortalCopyHandlers.onCopyFormBeforeRequest({ target: form });
        }
    });

    console.log('[LeapFILE] Portal copy fragment initialized');
}
